import Categories from './components/index'
import Farms from './components/farms/index'
import FarmData from './components/farms/components/farmData/index'
import Jobs from './components/jobs/index'
import Mekas from './components/mekas/index'
import Ribbons from './components/ribbons/index'
import Users from './components/users/index'
export default [
  {
    path: '/categories',
    component: Categories
  },
  {
    path: '/categories/farms',
    component: Farms
  },
  {
    path: '/categories/farms/entry',
    name: '/categories/farms/entry',
    component: FarmData,
    props: (route) => ({
      reportId: route.query.id,
      mode: route.params.mode
    })
  },
  {
    path: '/categories/jobs',
    component: Jobs
  },
  {
    path: '/categories/mekas',
    component: Mekas
  },
  {
    path: '/categories/ribbons',
    component: Ribbons
  },
  {
    path: '/categories/users',
    component: Users
  }
]
